import React, {Component} from 'react';
import DocumentTitle from 'react-document-title';
import marked from "marked";

import MarkdownRenderer from '../../components/MarkdownRenderer';

class Accessibility extends Component {

    constructor(props) {
        super(props);

        this.state = {
            markdown: ''
        }

        this.props.includeNav();
    }

    componentWillMount() {
        const markdownPath = require("./index.md");
        
        fetch(markdownPath)
            .then(response => {
                return response.text()
            })
            .then(text => {
                this.setState({
                    markdown: marked(text)
                })
            })
    }

    render() {

        return (
            <DocumentTitle
                title={'BCS Documentation - Accessibility'}>
                <section className="page" data-component="accessibility">
                    <div className="row">
                        <div className="col-xs-12 col-gutter-lr border-bottom">
                            <h1>Accessibility</h1>
                            <p>In accordance with the Americans With Disabilities Act ( ADA ) and Trilogy’s own Mission Statement, we have a commitment to making our services and platform accessible to as many segments of our community as possible. Our goal is to create accessible products that help a wide variety of learners, including individuals with disabilities. Unfortunately, it may not be possible, without undue effort or expense to accommodate all disabilities. We are considering learners with the following conditions in the design of our products.</p>
                            <ul className="bulleted">
                                <li>Vision impairments, including blindness, weak or low vision, photosensitivity, or color blindness.</li>
                                <li>Hearing impairments, including deafness or poor hearing.</li>
                                <li>Motor impairments, such as the inability to handle a mouse or operate a typical keyboard, whether through paralysis, limb loss or damage, pain, tremor, or another condition from injury or disease.</li>
                                <li>Speech, cognitive, or learning impairments.</li>
                            </ul>
                            <p>Specifically, we aim to ensure that Bootcamp Spot is <strong>WCAG - Level AA</strong> compliant.</p>
                        </div>
                        <div className="col-xs-12">
                            <MarkdownRenderer text={this.state.markdown}/>
                        </div>
                    </div>
                </section>
            </DocumentTitle>
        )
    }
}

export default Accessibility;



// WEBPACK FOOTER //
// ./src/pages/Accessibility/index.js